var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_748_926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 28.5C57 30.2239 56.8465 31.9119 56.5534 33.5508C54.1698 46.8819 42.5162 57 28.5 57C17.9399 57 8.721 51.2569 3.79807 42.7233C2.59639 40.6422 1.65189 38.396 1.00507 36.0263C0.349014 33.6289 0 31.1045 0 28.5C0 12.7599 12.7599 0 28.5 0C41.4913 0 52.4516 8.69194 55.8844 20.5781C56.6104 23.0931 57 25.7512 57 28.5Z",
    fill: "#8F9ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4925 19.8429H3.99633L1.00562 36.0262C1.65243 38.3958 2.59694 40.6421 3.79862 42.7232H4.77229L5.93088 36.4555H11.6983C18.7209 36.4555 20.6089 30.1507 21.0615 27.054C21.5152 23.9585 19.2503 19.8429 14.4925 19.8429ZM16.0152 27.5762C15.7582 29.3316 14.4611 32.9062 10.4804 32.9062H6.58694L8.32722 23.4873H12.2905C16.1537 23.4873 16.2723 25.8209 16.0152 27.5762Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8849 20.578C54.9927 20.1173 53.9294 19.8428 52.701 19.8428H42.2049L37.9764 42.7232H42.9807L44.1393 36.4555H49.9068C53.0302 36.4555 55.138 35.2085 56.5537 33.5508C56.847 31.9117 57.0005 30.2238 57.0005 28.4999C57.0005 25.7511 56.6109 23.093 55.8849 20.578ZM54.2238 27.5762C53.9667 29.3316 52.6696 32.9062 48.6878 32.9062H44.7955L46.5358 23.4873H50.4991C54.3623 23.4873 54.4808 25.8209 54.2238 27.5762Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.427 19.9186C32.3903 19.9186 29.6729 19.9186 28.3489 19.9186L29.4898 13.7454H24.506L20.2775 36.6251H25.2612L27.6929 23.4676C28.5913 23.4676 29.7848 23.4676 30.878 23.4676C32.9923 23.4676 34.427 23.9208 34.1249 25.884C33.8229 27.8473 32.0862 36.531 32.0862 36.531H37.1453C37.1453 36.531 39.1086 26.8657 39.4107 24.1472C39.7128 21.4288 37.2209 19.9186 34.427 19.9186Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_748_926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhp);
export default __webpack_public_path__ + "static/media/icon_php.02b2966ec2628143a986ae029715ce13.svg";
export { ForwardRef as ReactComponent };